module.exports = __webpack_public_path__ + "static/media/revue.f95ccb13.png";